/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAdmission } from 'app/shared/model/admission.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { ProcedurePriority } from 'app/shared/model/enumerations/procedure-priority.model';

export interface IMWLItem {
  id?: string;
  accessionNo?: string;
  createdTime?: number;
  institution?: string | null;
  department?: string | null;
  localAet?: string;
  modality?: string;
  reqProcId?: string;
  spsId?: string;
  spsStartDate?: number;
  spsStartTime?: number;
  spsStatus?: number;
  studyIuid?: string;
  updatedTime?: number;
  dicomAttrs?: string;
  instCode?: string | null;
  deptCode?: string | null;
  procedurePriority?: keyof typeof ProcedurePriority | null;
  admission?: IAdmission | null;
  admidIssuer?: IHospital | null;
  patient?: IGlucoUser | null;
  accnoIssuer?: IDiagLab | null;
  perfPhysName?: IDoctor | null;
  refPhysName?: IDoctor | null;
  reqPhysName?: IDoctor | null;
}

export const defaultValue: Readonly<IMWLItem> = {};
